import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  center: {
    lat: 46.7111,
    lng: 1.7191
  },
  zoom: 6,
  bounds: [],
  display: false,
};

const mapSettingsSlice = createSlice({
  name: 'mapSettings',
  initialState,
  reducers: {
    setZoom(state, { payload }) {
      state.zoom = payload;
    },
    setCenter(state, { payload }) {
      state.center = payload;
    },
    setBounds(state, { payload }) {
      state.bounds = payload;
    },
    setDisplay(state, { payload }) {
      state.display = payload;
    },
  },
})

export const { setZoom, setCenter, setBounds, setDisplay } = mapSettingsSlice.actions;

export default mapSettingsSlice.reducer;
